import Card from "../UI/Card";
import Accordion from "../UI/Accordion";
import MailTemplate from "./MailTemplate";
import useMailTemplatesCatalog from "../../hooks/use-mail-templates-catalog";
import Text from "../UI/Text";
import Title from "../UI/Title";
import styles from "./MailTemplatesList.module.css";

interface MailTemplatesListProps {
  profileBailleurId?: number;
  isProfile?: boolean;
}

export default function MailTemplatesList({
  profileBailleurId,
  isProfile,
}: MailTemplatesListProps) {
  const { catalog } = useMailTemplatesCatalog();

  if (!catalog || catalog.length === 0) return null;

  return (
    <Card>
      <div className={styles.header}>
        <Title variant="hecto" weight="medium">
          Modèles de mails
        </Title>
        <Text color="muted">
          Personnalisez le contenu des mails automatiques envoyés à vos
          locataires.
        </Text>
      </div>
      <Accordion>
        {catalog.map((meta) => (
          <MailTemplate
            key={meta.static_id}
            meta={meta}
            profileBailleurId={profileBailleurId}
            isProfile={isProfile}
          />
        ))}
      </Accordion>
    </Card>
  );
}
